export function forceReload(win) {
    if (win === void 0) { win = window; }
    var currentUrl = win.location.href;
    try {
        var urlObj = new URL(currentUrl);
        urlObj.searchParams.set('_r', Date.now().toString());
        win.location.replace(urlObj.toString());
    }
    catch (e) {
        win.location.reload();
    }
}
